import * as THREE from "three";
import { GLASS_PARAMS } from "./GlassDefeault";
import { applyRadiusColor } from "./RadiusColor";

export function createGlass1_SP(shearValue, topColor, bottomColor) {
  shearValue = shearValue !== undefined ? shearValue : 0.5;
  const group = new THREE.Group();

  // スケール調整
  const scaleFactor = GLASS_PARAMS.scaleFactor;

  // グラス(ダイソービールグラス400ml)
  const glassGeometry = new THREE.CylinderGeometry(
    GLASS_PARAMS.glass.topRadius * scaleFactor,
    GLASS_PARAMS.glass.bottomRadius * scaleFactor,
    GLASS_PARAMS.glass.height * scaleFactor,
    GLASS_PARAMS.glass.radialSegments,
    GLASS_PARAMS.glass.heightSegments,
    GLASS_PARAMS.glass.openEnded
  );



  const shearMatrix = new THREE.Matrix4();
  shearMatrix.set(
    1, 0, 0, 0, // X軸の変形
    0, 1, shearValue * 0.6, 0, // Y軸の変形 (ここがせん断)
    0, 0, 1, 0, // Z軸の変形
    0, 0, 0, 1 // 平行移動
  );

  // ジオメトリにせん断変形を適用
  glassGeometry.applyMatrix4(shearMatrix);

  // 変形で法線がずれるため再計算してから頂点色を割り当てる
  glassGeometry.computeVertexNormals();

  // 側面も同じ上端色で塗る
  applyRadiusColor(glassGeometry, topColor, bottomColor, GLASS_PARAMS.glass.color, topColor);

  const glassMaterial = new THREE.MeshPhongMaterial({
    color: 0xffffff,
    shininess: GLASS_PARAMS.glass.shininess,
    vertexColors: true,
  });
  const glassMesh = new THREE.Mesh(glassGeometry, glassMaterial);
  glassMesh.position.y = (GLASS_PARAMS.glass.height / 2) * scaleFactor;
  group.add(glassMesh);

  // 環境光とスポットライトを追加してリアルに照らす
  const ambientLight = new THREE.AmbientLight(
    GLASS_PARAMS.light.ambient.color,
    GLASS_PARAMS.light.ambient.intensity
  );
  const spotLight = new THREE.SpotLight(
    GLASS_PARAMS.light.spot.color,
    GLASS_PARAMS.light.spot.intensity
  );
  spotLight.position.set(
    ...GLASS_PARAMS.light.spot.position.map(v => v * scaleFactor)
  );
  spotLight.castShadow = true;
  group.add(ambientLight);
  group.add(spotLight);

  return group;
}
